import React, { Component } from 'react'
import './FarmsCard.css'

export default class FarmsCard extends Component {
    render() {
        return (
            <div className="farmcard_container">
                <div className="farmcard_header_flex">
                    <div className="farmcard_header_left">BUSD-KUSD</div>
                    <div className="farmcard_header_right">4X</div>
                </div>
                <div className="farmcard_content_area">
                    <div className="farmcard_content_item">
                        <div className="farmcard_content_left">APR</div>
                        <div className="farmcard_content_right">340%</div>
                    </div>
                    <div className="farmcard_content_item">
                        <div className="farmcard_content_left">Earn</div>
                        <div className="farmcard_content_right">KONST</div>
                    </div>
                    <div className="farmcard_content_item">
                        <div className="farmcard_content_left">Total Staked</div>
                        <div className="farmcard_content_right">23,220</div>
                    </div>
                    <div className="farmcard_content_item">
                        <div className="farmcard_content_left">LP Token Type</div>
                        <div className="farmcard_content_right">CAKE-LP</div>
                    </div>
                    
                </div>
                <div className="farmcard_hr_container">
                    <div className="farmcard_hr"></div>
                </div>
                <div className="farmcard_harvest_container">
                    <div className="farmcard_harvest_topic">KONST Earned</div>
                    <div className="farmcard_harvest_flex">
                        <div className="farmcard_harvest_left">0.0000</div>
                        <div className="farmcard_harvest_right">Harvest</div>
                    </div>
                    <div className="farmcard_submit_button">
                        Approve Contract
                    </div>
                </div>

             
            </div>
        )
    }
}
